import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=990184fa&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=990184fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990184fa",
  null
  
)

export default component.exports